export const WHATSAPP_NUMBER = "5592981378336";
export const WHATSAPP_DISPLAY = "(92) 98137-8336";
export const EMAIL = "francisco@fmaciel.com.br";
export const LOCATION = "Manaus — Amazonas";

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const SERVICES = [
  {
    id: "incendio",
    code: "01",
    title: "Projetos de Combate a Incêndio",
    text: "Sistemas de hidrantes, sprinklers, extintores e rotas de fuga dimensionados para proteger pessoas, patrimônio e garantir a aprovação junto aos órgãos competentes.",
    tags: ["Hidrantes", "Sprinklers", "Extintores"],
    image: "/assets/piping.jpg",
  },
  {
    id: "ar-comprimido",
    code: "02",
    title: "Projetos de Redes de Ar Comprimido",
    text: "Dimensionamento de compressores, reservatórios, tratamento e distribuição — redes eficientes, com menos perdas de carga e vazamentos.",
    tags: ["Compressores", "Distribuição", "Eficiência"],
    image: "/assets/hero.jpg",
  },
  {
    id: "utilidades",
    code: "03",
    title: "Projetos de Utilidades",
    text: "Tubulações industriais, vapor, água gelada, gases e fluidos de processo integrados ao layout da planta com segurança e facilidade de manutenção.",
    tags: ["Tubulações", "Vapor", "Fluidos"],
    image: "/assets/factory.jpg",
  },
  {
    id: "estruturas",
    code: "04",
    title: "Projetos de Estruturas Metálicas",
    text: "Cálculo e projeto de galpões metálicos, tanques metálicos, mezaninos, escadas, plataformas, passarelas e outras estruturas metálicas, com dimensionamento seguro e lista de materiais otimizada.",
    tags: ["Galpões metálicos", "Tanques metálicos", "Mezaninos"],
    image: "/assets/estruturas.jpg",
  },
  {
    id: "rigging",
    code: "05",
    title: "Elaboração de Planos de Rigging",
    text: "Planejamento de içamentos e movimentação de cargas: seleção de guindaste, capacidade, ângulos de lingas e acessórios para operações seguras.",
    tags: ["Içamento", "Guindastes", "Segurança"],
    image: "/assets/rigging.jpg",
  },
  {
    id: "consultorias",
    code: "06",
    title: "Consultorias",
    text: "Diagnóstico técnico, análise de viabilidade, adequações e pareceres para decisões de engenharia mais seguras e economicamente sustentáveis.",
    tags: ["Diagnóstico", "Pareceres", "Adequações"],
    image: "/assets/steel.jpg",
  },
  {
    id: "treinamentos",
    code: "07",
    title: "Treinamentos",
    text: "Capacitação técnica e de segurança para equipes operacionais e de manutenção, com conteúdo prático aplicado à realidade da sua planta.",
    tags: ["Segurança", "Operação", "Manutenção"],
    image: "/assets/machinery.jpg",
  },
];

const S = "/assets/suite";
const E = "/assets/estruturas-app";

// Preencha `url` com o link de compra de cada app. Vazio = abre o WhatsApp.
export const APPS = [
  {
    id: "estruturas", name: "Estruturas", full: "FMaciel Estruturas", tagline: "Galpões, escadas e mezaninos", logo: `${S}/ic-est.webp`, phase: "projeto", url: "",
    text: "Cálculo e projeto de galpões metálicos, escadas e mezaninos. Você escolhe o modelo, ajusta geometria e cargas, e o programa seleciona os perfis mais leves, verifica as barras e entrega peso, custo e memorial.",
    para: "Engenheiros, projetistas e fabricantes de estruturas metálicas.",
    features: ["6 modelos de galpão, com escadas e mezaninos", "Análise 2D e 3D, combinações e vento", "Seleção automática dos perfis mais leves", "Ligações, lista de materiais e memorial", "Peso e custo estimado do aço em tempo real"],
    shots: [
      { src: `${E}/4.webp`, label: "Modelo 3D" },
      { src: `${S}/est.webp`, label: "Galpões e coberturas" },
      { src: `${E}/1.webp`, label: "Tipos de galpão" },
      { src: `${E}/2.webp`, label: "Dimensionamento" },
      { src: `${E}/5.webp`, label: "Envoltória de esforços" },
      { src: `${E}/3.webp`, label: "Detalhe da telha" },
      { src: `${E}/7.webp`, label: "Escadas e mezaninos" },
      { src: `${E}/8.webp`, label: "Passarela com escadas" },
      { src: `${E}/9.webp`, label: "Verificações de barras" },
      { src: `${E}/6.webp`, label: "Studio de Ligações" },
    ],
  },
  {
    id: "acometria", name: "AçoMetria", full: "FMaciel AçoMetria", tagline: "Peso, metragem e área de aço", logo: `${S}/ic-aco.webp`, phase: "projeto", url: "",
    text: "Calcula peso, comprimento e área superficial de perfis, chapas, tubos e barras, nos dois sentidos: do comprimento para o peso ou do peso para o comprimento. Monta o levantamento e exporta para orçamento.",
    para: "Orçamentistas, caldeirarias, serralherias e compras.",
    features: ["Banco com 5.627 perfis do Brasil, EUA e Europa", "Cálculo direto e reverso", "Área superficial para pintura e galvanização", "Visualização 3D da seção", "Levantamento exportável"],
    shots: [{ src: `${S}/aco.webp`, label: "Calculadora" }],
  },
  {
    id: "rigging", name: "Rigging", full: "FMaciel Rigging", tagline: "Planos de içamento de cargas", logo: `${S}/ic-rig.webp`, phase: "obra", url: "",
    text: "Monta o plano de içamento completo: carga, equipamento, lingas e acessórios, solo e etapas da movimentação. Verifica cada item contra a capacidade e gera croqui em planta e elevação e o relatório em PDF.",
    para: "Equipes de montagem, segurança do trabalho e operadores de guindaste e munck.",
    features: ["Verificação de lingas, manilhas, moitão e equipamento", "Pressão no solo e limite de vento", "Croqui em planta e elevação por etapa", "Lista de pendências antes da liberação", "Relatório e plano em PDF"],
    shots: [{ src: `${S}/rig.webp`, label: "Painel do plano" }, { src: `${S}/rig2.webp`, label: "Croqui e etapas" }],
  },
  {
    id: "obras", name: "Gestão de Obras", full: "FMaciel Gestão de Obras", tagline: "Orçamentos, contratos e obras", logo: `${S}/ic-obr.webp`, phase: "obra", url: "",
    text: "Do orçamento à obra entregue: propostas, contratos e aditivos, medições, avanço físico, terceirizados, compras e custos. Funciona com vários usuários conectados a um servidor central.",
    para: "Construtoras e empresas de montagem que trabalham em equipe.",
    features: ["Orçamentos e propostas comerciais", "Medições e avanço previsto × realizado", "Custos, compras e saldo do orçamento", "Multiusuário com servidor central", "Histórico e auditoria"],
    shots: [{ src: `${S}/obr.webp`, label: "Painel de obras" }],
  },
  {
    id: "rdo", name: "RDO", full: "FMaciel RDO", tagline: "Relatório Diário de Obra", logo: `${S}/ic-rdo.webp`, phase: "obra", url: "",
    text: "Registra o dia de cada obra: efetivo, equipamentos, atividades, clima, ocorrências e fotos. Acompanha o avanço, o efetivo dos últimos dias e os relatórios que aguardam aprovação da fiscalização.",
    para: "Engenheiros residentes, encarregados e fiscais de obra.",
    features: ["Painel com obras, efetivo e pendências", "Modelos de RDO reutilizáveis", "Consolidado por obra", "Fluxo de emissão e aprovação", "PDF personalizado com a sua marca"],
    shots: [{ src: `${S}/rdo.webp`, label: "Painel de obras" }],
  },
  {
    id: "pcm", name: "PCM", full: "FMaciel PCM", tagline: "Planejamento e controle da manutenção", logo: `${S}/ic-pcm.webp`, phase: "manutencao", url: "",
    text: "Cadastro de ativos e criticidade, planos de manutenção, mapa de 52 semanas e ordens de serviço. Mede aderência ao plano, disponibilidade, MTBF e MTTR, com estoque e análise de falhas.",
    para: "Gestores, planejadores e técnicos de manutenção industrial.",
    features: ["Mapa de 52 semanas", "Ordens de serviço e horímetro", "Disponibilidade, MTBF e MTTR", "Estoque e análise de falhas", "Indicadores, custos e PDF"],
    shots: [{ src: `${S}/pcm.webp`, label: "Painel de manutenção" }],
  },
  {
    id: "pmoc", name: "PMOC", full: "FMaciel PMOC", tagline: "Manutenção de climatização", logo: `${S}/ic-pmoc.webp`, phase: "manutencao", url: "",
    text: "Plano de Manutenção, Operação e Controle dos sistemas de ar-condicionado: ambientes, equipamentos, plano, cronograma, execuções e qualidade do ar, com verificação de completude documental.",
    para: "Responsáveis técnicos e empresas de manutenção de climatização.",
    features: ["Modelos prontos: escritório, clínica, hospital, hotel", "Cronograma e registro de OS", "Qualidade do ar (ABNT NBR 17037)", "Verificação dos itens do Anexo I", "Relatório em PDF"],
    shots: [{ src: `${S}/pmoc.webp`, label: "Modelos de PMOC" }],
  },
  {
    id: "pgr", name: "PGR", full: "FMaciel PGR", tagline: "Gerenciamento de riscos · NR-01", logo: `${S}/ic-pgr.webp`, phase: "seguranca", url: "",
    text: "Elabora o Programa de Gerenciamento de Riscos: organização, ambientes e GHE, inventário de riscos, matriz severidade × probabilidade e plano de ação. Confere os requisitos mínimos da NR-01 antes de emitir.",
    para: "Técnicos e engenheiros de segurança do trabalho e consultorias de SST.",
    features: ["Matriz de risco 5 × 5 clicável", "Inventário por ambiente e GHE", "Plano de ação com prazos e atrasos", "Checklist dos requisitos mínimos do PGR", "Revisões e versões do documento"],
    shots: [{ src: `${S}/pgr.webp`, label: "Matriz de riscos" }],
  },
  {
    id: "certificados", name: "Certificados", full: "FMaciel Certificados", tagline: "Certificados de treinamento", logo: `${S}/ic-cert.webp`, phase: "seguranca", url: "",
    text: "Emite certificados de treinamento por turma e controla a validade de cada participante. Já vem com 77 treinamentos cadastrados, com carga horária, conteúdo programático e referência normativa.",
    para: "Empresas de treinamento, SESMT e RH.",
    features: ["77 treinamentos de NR prontos", "Emissão em lote por turma", "Controle de validades", "Histórico de certificados", "Aproveitamento de treinamento anterior"],
    shots: [{ src: `${S}/cert.webp`, label: "Emitir certificados" }],
  },
];

export const PHASES = [
  { id: "projeto", n: "01", title: "Projeto", text: "Dimensione, quantifique e orçe antes de cortar o primeiro perfil." },
  { id: "obra", n: "02", title: "Obra", text: "Planeje içamentos, controle contratos e registre cada dia de obra." },
  { id: "manutencao", n: "03", title: "Manutenção", text: "Mantenha ativos e climatização dentro do plano, com indicadores." },
  { id: "seguranca", n: "04", title: "Segurança", text: "Gerencie riscos e mantenha os treinamentos da equipe em dia." },
];

export const DELIVERABLES = ["Memorial de cálculo", "Desenhos para execução", "Documentação para aprovação", "Acompanhamento em campo"];

export const STEPS = [
  { n: "01", title: "Diagnóstico", text: "Visita técnica, levantamento de dados e entendimento das necessidades da operação." },
  { n: "02", title: "Engenharia", text: "Cálculos, dimensionamentos e modelagem com foco em segurança e eficiência." },
  { n: "03", title: "Documentação", text: "Memoriais, desenhos e especificações claras, prontas para execução e aprovação." },
  { n: "04", title: "Acompanhamento", text: "Suporte técnico durante a implantação até o resultado em campo." },
];

export const MARQUEE = [
  "Combate a Incêndio",
  "Ar Comprimido",
  "Utilidades",
  "Estruturas Metálicas",
  "Planos de Rigging",
  "Consultorias",
  "Treinamentos",
  "FMACIEL Suite",
];
